<div class="relative fix-height flex column center justify-center full-width tint">
  <!-- <img src="assets/background.jpg" class="full-width full-height background" /> -->

  <div class="flex column">
    <h3>
      Welcome to the new
      <span class="primary-dark">Basic Studios</span>
      !
    </h3>

    Please choose one of the options below to continue:

    <div class="flex center gap margin-top">
      <div
        class="fix flex column justify-center center bg-white padding border border-blue hover radius"
        (click)="onNavigateToOrders()"
      >
        <i class="fa-solid fa-dolly fa-3x"></i>
        <h4 class="margin-top-small">Manage orders</h4>
        <span class="grey margin-top-smallest">Create or manage orders</span>
      </div>

      <div
        class="fix flex column justify-center center bg-white padding border border-blue hover radius"
        (click)="onNavigateToStyles()"
      >
        <i class="fa-solid fa-images fa-3x"></i>
        <h4 class="margin-top-small">Manage media</h4>
        <span class="grey margin-top-smallest">Upload media manually</span>
      </div>
    </div>
  </div>
</div>
